export default __webpack_public_path__ + "static/media/sdg.7af2d748.png";